import React, { createContext, useContext, useState, useCallback } from "react";
import { dataService } from "../services/dataService";
import Modal from "../components/modals/Modal";
import { useOrder } from "./OrderContext";
import { useLocation } from "react-router-dom";
import { IconAlertCircle } from "@tabler/icons-react";

const InvoiceSaveContext = createContext();

export const InvoiceSaveProvider = ({ children }) => {
    const [modal, setModal] = useState({ open: false, message: "", type: "danger" });
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const { order, replaceOrder } = useOrder();
    const location = useLocation();

    const closeModal = () => setModal({ open: false, message: "", type: "danger" });

    const saveInvoice = useCallback(
        async (invoiceData) => {
            const calculated_path = location.pathname.startsWith("/")
                ? location.pathname.slice(1)
                : location.pathname;

            console.log("Számla mentés helye:", calculated_path);

            const invoiceDataWithPath = {
                ...invoiceData,
                hmeliorder_szam: order.hmeliorder?.hmeliorder_szam,
                save_path_source: calculated_path,
            };

            setLoading(true);
            try {
                const response = await dataService.saveInvoice(invoiceDataWithPath);
                const data = response.data;

                if (data.status === "error") {
                    setModal({
                        open: true,
                        message:
                            "<h4>" +
                            data.message +
                            '</h4> <span style="color: grey">Kérem, próbálkozzon újra!</span>' ||
                            "Hiba történt a számla mentésekor! Kérem, próbálja újra!",
                        type: "danger",
                    });
                    return { success: false, error: data.message };
                }

                const newInvoicesData = data.data.szamlak;
                replaceOrder({
                    ...order,
                    szamlak: newInvoicesData,
                });

                setSuccessMessage("Sikeres számla mentés!");
                setTimeout(() => setSuccessMessage(""), 2000);
                return { success: true, data };
            } catch (error) {
                setModal({
                    open: true,
                    message: "Hiba történt a számla mentésekor! Kérem, próbálja meg újból!",
                    type: "danger",
                });
                return { success: false, error: error.message };
            } finally {
                setLoading(false);
            }
        },
        [replaceOrder, location, order]
    );


    return (
        <InvoiceSaveContext.Provider value={{ saveInvoice, loading, setLoading, successMessage, setSuccessMessage }}>
            {children}
            <Modal
                isOpen={modal.open}
                onClose={closeModal}
                onConfirm={closeModal}
                title={modal.type === "success" ? "Siker" : "Hiba"}
                type={modal.type}
                confirmText="OK"
                showCancel={false}
                icon={<IconAlertCircle size={48} stroke={2} className="text-danger" />}
            >
                <div dangerouslySetInnerHTML={{ __html: modal.message }} />
            </Modal>
        </InvoiceSaveContext.Provider>
    );
};

export const useInvoiceSave = () => useContext(InvoiceSaveContext);